import React, { Component } from 'react';
import {
  DataTable,
  TableBody,
  TableColumn,
  TableHeader,
  TablePagination, TableRow
} from 'react-md';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import '../css/SectionWidgetTable.css';
import { AppProperties } from '../common/function';



export default class SectionListWidget extends Component {
  appProperties = AppProperties();
  constructor(props) {
    super(props);

    this.state = {
      section_data: [],
      slicedData: [],
      loading: true
    };
  }

  componentWillUpdate(nextProps, nextState) {
    console.debug('componentWillUpdate');
  }

  //
  getSectionData(req_course_id) {
    const payload = { course_id: req_course_id };

    return new Promise(function(resolve, reject) {
      ApiRequestService({
        method: 'post',
        url: '/getAllSections',
        data: payload
      })
        .then(res => {
          if (
            res.data.data.section_names !== null &&
            res.data.data.section_names !== undefined &&
            res.data.data.section_names.length > 0
          ) {
            return resolve(res.data.data.section_names);
          } else {
            console.error('Section Data Empty');
            let emptyArray = [];
            return resolve(emptyArray);
          }
        })
        .catch(error => {
          console.error('Error When Retriving Section Details ', error);
          reject(error, null);
        });
    });
  }
  componentWillMount() {
    console.debug('this.props.course_id', this.props.course_id);

    this.getSectionData(this.props.course_id).then(section_names => {
      this.setState({
        section_data: section_names,
        slicedData: section_names.slice(0, 4),
        loading: false
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    console.debug('componentWillReceiveProps');
    if (nextProps.course_id !== this.props.course_id) {
      this.setState({ loading: true });
      this.getSectionData(nextProps.course_id).then(section_names => {
        console.debug(
          'componentWillReceiveProps' + JSON.stringify(section_names)
        );

        this.setState({
          section_data: section_names,
          slicedData: section_names.slice(0, 4)
        });
        this.setState({ loading: false });
      });
    }
  }
  //
  handlePagination = (start, rowsPerPage) => {
    this.setState({
      slicedData: this.state.section_data.slice(start, start + rowsPerPage)
    });
  };

  onSectionClick = data => {
    console.debug(data._targetInst._hostParent._currentElement.props);

    let sectionID = data._targetInst._hostParent._currentElement.props.id;
    let sectionName = data._targetInst._hostParent._currentElement.props.name;
    this.props.onClick(sectionID, sectionName);
  };

  render() {
    const { slicedData, section_data } = this.state;
    const rows = section_data.length;

    if (this.state.loading) return <LoadingSpinner loading={true} />;

    if (rows > 0) {
      return (
        <DataTable plain baseId="simple-pagination">
          <TableHeader>
            <TableRow>
              <TableColumn className="SectionWidgetHeaderStyle">
                Section ID
              </TableColumn>
              <TableColumn className="SectionWidgetHeaderStyle">
                Section Name
              </TableColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            {slicedData.map((rowData, key) => (
              <TableRow
                key={'' + key}
                selectable={false}
                onClick={() =>
                  this.props.onClick(rowData.section_id, rowData.section_name)
                }
              >
                <TableColumn className="SectionWidgetTextStyleII">
                  {rowData.section_id}
                </TableColumn>
                <TableColumn className="SectionWidgetTextStyleI">
                  {rowData.section_name}
                </TableColumn>
              </TableRow>
            ))}
          </TableBody>
          <TablePagination
            simplifiedMenu
            rowsPerPageItems={[4, 8, 12, 16, 20]}
            defaultRowsPerPage={4}
            rows={rows}
            rowsPerPageLabel=""
            onPagination={this.handlePagination}
          />
        </DataTable>
      );
    }

    return (
      <div>
        <span className="md-text-center md-font-medium">
          {' '}
         {this.appProperties.schoolMode?"No Sections Found for Standard":"No Sections Found for Course"} {' '}
        </span>
      </div>
    );
  }
}
